import { LineChart } from '@/components/charts/LineChart';

function BaseComponent({
  data,
  dot,
}: {
  data: {
    name: string;
    assets: number;
  }[];
  dot?: boolean;
}) {
  return (
    <LineChart
      dot={dot}
      data={data}
      lines={[
        {
          dataKey: 'assets',
          dotClassName: 'stroke-chariot-brand-primary',
          lineClassName:
            '[&>path]:stroke-chariot-brand-primary text-chariot-brand-primary',
        },
      ]}
    />
  );
}

const sampleData = [...Array(5).keys()].map(i => ({
  name: `Jan ${i + 1}`,
  assets: Math.floor(Math.random() * 50),
}));

export function AssetsOvertimeExample() {
  return <BaseComponent data={sampleData} dot={true} />;
}
